export function SkeletonCard() {
  return (
    <div style={{ background: '#151230', border: '1px solid #2d1f6e', borderRadius: 16, overflow: 'hidden' }} className="animate-shimmer">
      <div style={{ height: 40, background: 'rgba(45,31,110,0.3)' }} />
      <div style={{ padding: '16px 20px' }}>
        <div style={{ height: 12, background: 'rgba(45,31,110,0.4)', borderRadius: 4, width: '66%', marginBottom: 8 }} />
        <div style={{ height: 28, background: 'rgba(45,31,110,0.4)', borderRadius: 4, width: '50%' }} />
      </div>
    </div>
  );
}

export function SkeletonChart() {
  return (
    <div style={{ background: '#151230', border: '1px solid #2d1f6e', borderRadius: 16, padding: 24 }} className="animate-shimmer">
      <div style={{ height: 16, background: 'rgba(45,31,110,0.4)', borderRadius: 4, width: '33%', marginBottom: 16 }} />
      <div style={{ height: 192, background: 'rgba(45,31,110,0.2)', borderRadius: 8 }} />
    </div>
  );
}

export function SkeletonProductCard() {
  return (
    <div style={{ background: '#151230', border: '1px solid #2d1f6e', borderRadius: 16, overflow: 'hidden' }} className="animate-shimmer">
      <div style={{ aspectRatio: '4/3', background: 'rgba(45,31,110,0.2)' }} />
      <div style={{ padding: 20 }}>
        <div style={{ height: 20, background: 'rgba(45,31,110,0.4)', borderRadius: 4, width: '75%', marginBottom: 12 }} />
        <div style={{ height: 12, background: 'rgba(45,31,110,0.3)', borderRadius: 4, width: '100%', marginBottom: 12 }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 12, borderTop: '1px solid #2d1f6e' }}>
          <div style={{ height: 24, background: 'rgba(45,31,110,0.4)', borderRadius: 4, width: 96 }} />
          <div style={{ height: 16, background: 'rgba(45,31,110,0.3)', borderRadius: 4, width: 64 }} />
        </div>
      </div>
    </div>
  );
}

export function SkeletonTable({ rows = 5 }) {
  return (
    <div style={{ background: '#151230', border: '1px solid #2d1f6e', borderRadius: 16, overflow: 'hidden' }} className="animate-shimmer">
      <div style={{ height: 48, background: 'rgba(45,31,110,0.2)', borderBottom: '1px solid #2d1f6e' }} />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: 'flex', gap: 16, padding: '12px 20px', borderBottom: '1px solid rgba(45,31,110,0.3)' }}>
          <div style={{ height: 16, background: 'rgba(45,31,110,0.3)', borderRadius: 4, flex: 1 }} />
          <div style={{ height: 16, background: 'rgba(45,31,110,0.3)', borderRadius: 4, width: 80 }} />
          <div style={{ height: 16, background: 'rgba(45,31,110,0.3)', borderRadius: 4, width: 80 }} />
          <div style={{ height: 16, background: 'rgba(45,31,110,0.3)', borderRadius: 4, width: 64 }} />
        </div>
      ))}
    </div>
  );
}
